import { TrackApiService } from '@/infrastructure/api-functions/track-api-service';
import type { TrackData } from '@/types';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';

export interface TrackService {
    trackAir(data: TrackData): Promise<boolean>;
    trackSeek(data: TrackData): Promise<boolean>;
}

export const TrackService = Symbol('TrackService');

@injectable()
export class TrackServiceImpl implements TrackService {
    constructor(
        @inject(TrackApiService) private trackApiService: TrackApiService
    ) {
    }

    trackAir(data: TrackData) {
        return this.trackApiService.track(data);
    }

    trackSeek(data: TrackData) {
        return this.trackApiService.track({
            event_type: '',
            source_type: '',
            ...data,
        });
    }
}
